/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { GetConnectionQueryResponse, GetConnectionPathParams } from "../models/GetConnection";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getConnection } from "../axios/getConnection";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getConnectionQueryKey = (station: GetConnectionPathParams["station"], platform: GetConnectionPathParams["platform"]) => ["social-export-api", { url: '/connections/:station/:platform', params: {station:station,platform:platform} }] as const

export type GetConnectionQueryKey = ReturnType<typeof getConnectionQueryKey>

export function getConnectionQueryOptions(station: GetConnectionPathParams["station"], platform: GetConnectionPathParams["platform"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getConnectionQueryKey(station, platform)
        return queryOptions<GetConnectionQueryResponse, ResponseErrorConfig<Error>, GetConnectionQueryResponse, typeof queryKey>({
         enabled: !!(station&& platform),
         queryKey,
         queryFn: async ({ signal }) => {
            return getConnection(station, platform, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get connection state for a station
 * {@link /connections/:station/:platform}
 */
export function useGetConnection<TData = GetConnectionQueryResponse, TQueryData = GetConnectionQueryResponse, TQueryKey extends QueryKey = GetConnectionQueryKey>(station: GetConnectionPathParams["station"], platform: GetConnectionPathParams["platform"], options: 
{
  query?: Partial<QueryObserverOptions<GetConnectionQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getConnectionQueryKey(station, platform)
         

         const query = useQuery({
          ...getConnectionQueryOptions(station, platform, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}